import { makeAutoObservable } from 'mobx';
import {
  CuePointType,
  Track
} from '../presentation-config-aggregate-types/presentation-config-aggregate-types';
import CuePointEntity from '../cue-point-entity/cue-point-entity';

class TrackEntity {
  private cuePoints: CuePointEntity[];

  constructor (fromDTO: Track = {} as Track) {
    makeAutoObservable(this);
    this.deserialize(fromDTO);
  }

  public getCuePoints = (): CuePointEntity[] => {
    return this.cuePoints;
  };

  private deserialize = (fromDTO: Track): void => {
    this.cuePoints = fromDTO.cuePoints && fromDTO.cuePoints.cuePoint ?
      fromDTO.cuePoints.cuePoint.filter(x => x.type !== CuePointType.blank).map(x => new CuePointEntity(x))
      : [];
  };
}

export default TrackEntity;
